<template>
  <div class="t-review">
    <TAvatar
      :img-prop="imgProp"
      size="md"
      variant="image"
      :title="title"
      :subtitle="subtitle"
      class="mb-1"
    />

    <TStars class="mb-2" :stars="stars" />
    <UButton
      v-if="variant !== 'no-link' && linkCottage"
      variant="link"
      size="lg"
      color="neutral"
      :padded="false"
      external
      :to="linkCottage"
    >
      {{ textLeading }}
    </UButton>

    <TText classes="mb-2" clamp="clamp3">
      {{ removeCarriageReturns(text) }}
    </TText>
    <UButton
      v-if="variant !== 'no-review-link'"
      variant="link"
      size="sm"
      color="neutral"
      :padded="false"
      external
      :to="linkHref"
    >
      {{ linkText }}
    </UButton>
  </div>
</template>

<script setup lang="ts">
import type { TLazyimg_Props } from '~/modules/design-system/components/t-lazyimg/constants/types'
import removeCarriageReturns from '~/utils/removeCarriageReturns'

export type reviewVariant = 'default' | 'no-link' | 'no-review-link'
export interface Props {
  title?: string
  subtitle?: string
  imgUrl?: string
  stars?: number
  text?: string
  textLeading?: string
  linkCottage?: string
  linkText?: string
  linkHref?: string
  variant?: reviewVariant
}

const props = withDefaults(defineProps<Props>(), {
  title: '',
  subtitle: '',
  imgUrl: '',
  stars: 0,
  text: '',
  textLeading: '',
  linkText: '',
  linkHref: '',
  variant: 'default',
})

const imgProp: TLazyimg_Props = {
  sources: { url: props.imgUrl as string },
  alt: props.title,
}
</script>
